export { fa } from '@payloadcms/translations/languages/fa'
